<div class="grid-container">
	<div class="calendar-grid" [ngStyle]="{ 'grid-template-columns': 'repeat(' + (displayDates.length + 1) + ', auto)' }">
		<div class="top-left-corner-cell"></div>
		<div class="date-column-header"
			 *ngFor="let date of displayDates; let dateIdx = index"
			 (click)="dateHeader_clicked(date)">
			<div class="day-of-week-header">{{ date | cassDate: 'cccccc' }}</div>
			<div class="day-of-month-header">{{ date | date: 'd' }}</div>
			<div class="month-header">{{ date | cassDate: 'LLL' }}</div>
		</div>
		<ng-container *ngFor="let pubIssuesVM of pubsAndIssuesVMs; let rowIdx = index; let lastRow = last">
			<div class="product-row-header" [ngClass]="{ 'last-row': lastRow }">
				{{ pubIssuesVM.pubName }}
				<div class="chip" [ngStyle]="{ visibility: pubIssuesVM.numberOfSelectedDates > 0 ? 'visible' : 'hidden' }">
					<span>{{ pubIssuesVM.numberOfSelectedDates }}</span>
				</div>
			</div>
			<div class="selector-cell" *ngFor="let dateVM of pubIssuesVM.issues"
				 [class.pending]="dateVM.nullableIsValid === undefined"
				 [class.valid]="dateVM.nullableIsValid === true"
				 [class.invalid]="dateVM.nullableIsValid === false"
				 [class.selected]="dateVM.isSelected"
				 [class.last-row]="lastRow"
				 (click)="singleDate_clicked(pubIssuesVM.pubId, dateVM.dateCode)">
				{{ dateVM.nullableIsValid === undefined ? "&bull;&bull;&bull;" : dateVM.displayDate }}
			</div>
		</ng-container>
	</div>
</div>
